$(document).ready(function () {
      const modes = ["light", "dark", "auto"];
      // Dark mode disabled: always force light regardless of any stored preference.
      let current = "light";

      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");

      function applyTheme(theme) {
        const icon = $("#theme-icon");

        if (theme === "light") {
          $("html").removeClass("dark");
          localStorage.theme = "light";
          icon.attr("class", "bi bi-sun-fill");
        } else if (theme === "dark") {
          $("html").addClass("dark");
          localStorage.theme = "dark";
          icon.attr("class", "bi bi-moon-stars-fill");
        } else {
          localStorage.removeItem("theme"); // auto
          if (prefersDark.matches) {
            $("html").addClass("dark");
          } else {
            $("html").removeClass("dark");
          }
          icon.attr("class", "bi bi-circle-half");
        }
      }

      // Apply current mode on load
      applyTheme(current);

      // Cycle through modes on click
      $("#theme-toggle").on("click", function () {
        let idx = modes.indexOf(current);
        current = modes[(idx + 1) % modes.length];
        applyTheme(current);
      });

      // 🔥 Listen for system color scheme changes (for Auto mode)
      prefersDark.addEventListener("change", (e) => {
        if (!localStorage.theme) { // only when in Auto mode
          if (e.matches) {
            $("html").addClass("dark");
          } else {
            $("html").removeClass("dark");
          }
        }
      });
});
 
 
 $(function () {
  var hasTz = $.grep(document.cookie.split('; '), function (c) {
    return c.indexOf('tz=') === 0;
  }).length > 0;

  if (!hasTz) {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    document.cookie = 'tz=' + tz + ';path=/;max-age=31536000;SameSite=Lax';
    // console.log('Set tz cookie:', tz, '— reloading to apply server-side formatting');
    location.reload();
  }
});
 
if (window.location.pathname !== '/login') {
 const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('overlay');
    const openBtn = document.getElementById('openSidebar');
    const closeBtn = document.getElementById('closeSidebar');

    function openSidebar() {
      sidebar.classList.remove('-translate-x-full');
      overlay.classList.remove('hidden');
    }
    function closeSidebar() {
      sidebar.classList.add('-translate-x-full');
      overlay.classList.add('hidden');
    }

    openBtn?.addEventListener('click', openSidebar);
    closeBtn?.addEventListener('click', closeSidebar);
    overlay?.addEventListener('click', closeSidebar);

    // Close sidebar on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSidebar();
    });

    // Highlight active sidebar link
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    sidebar.querySelectorAll('nav a[href]').forEach(link => {
      const href = link.getAttribute('href').replace(/\/+$/, '') || '/';
      const isActive = (href === '/' && path === '/') || (href !== '/' && path.startsWith(href));
      if (isActive) {
        link.classList.remove('text-slate-700', 'hover:bg-slate-50', 'hover:text-slate-900');
        link.classList.add('bg-slate-100', 'dark:bg-slate-50/20', 'text-slate-900', 'dark:text-white', 'font-medium');
        // For sub-links inside <details>, change the dot color
        const dot = link.querySelector('.rounded-full');
        if (dot) {
          dot.classList.remove('bg-slate-300');
          dot.classList.add('bg-blue-500');
        }
        // Auto-open parent <details> if link is inside one
        const details = link.closest('details');
        if (details) details.setAttribute('open', '');
      }
    });
}